import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { State } from '../../../reducers';
import { setAnuladoFactura, setStatusModalAnular, setStatusModalEnvio, setStatusModalImprimir, setStatusModalOpciones } from '../../../actions/historial/historial.actions';

import ModalHistorialAcciones from '../../../components/Modals/ModalsFacturacion/ModalHistorialAcciones';
import ModalEnviarEmail from '../../../components/Modals/ModalsFacturacion/ModalEnviarEmail';
import ModalAnularFactura from '../../../components/Modals/ModalsFacturacion/ModalAnularFactura';
import ModalImprimirFactura from '../../../components/Modals/ModalsFacturacion/ModalImprimirFactura';

import { actionsHistorialFiltro, actionsOperaciones } from '../../../actions/action-creators';
import { generalOpenModalMessage } from '../../../actions/general.actions';
import { emailInvoice } from '../../../utils/invoice/validateSendInvoice';
import { OPSendEmail } from '../../../interfaces/operaciones.interface';
import { useEffect, useMemo } from 'react';
import { generateQRImageFromBits } from '../../../actions/operaciones/operaciones.actions';
import { unirChipsArray } from '../../../utils/strings.utils';

const ModalsControl = () => {
  const {activeAnular, activeEnvioCorreo, activeOpciones, activePrint} = useSelector((state: State) => state.historial.modals);
  const {activeFactura, qrFactura, anulado, itemsAnular, resultAnulaciones, formFilter, arrayFacturas} = useSelector((state: State) => state.historial);
  
  

  const dispatch = useDispatch();

  const {sendEmailPDF, anularFactura} = bindActionCreators(actionsOperaciones, dispatch);
  const {historialHandleAnulaciones, getTransactions} = bindActionCreators(actionsHistorialFiltro, dispatch);

  const handleEnviarEmail = async (formEnvio: emailInvoice) => {
    const sendEmail: OPSendEmail = {
      Correo: formEnvio.email,
      Sello: activeFactura?.sellorecibido,
      IdSucursalDoc: activeFactura?.DetallesDTE?.identificacion?.IDsucursalDoc || "-1"
    }
    if (await sendEmailPDF(sendEmail)) {
      dispatch(generalOpenModalMessage(`Enviar por correo electrónico`, `El correo electrónico fue enviado exitosamente.`))
      dispatch(setStatusModalEnvio(false));
    }
  }

  const handleAnular = () => {
    let arrayAnular;

    if (activeFactura) arrayAnular = [activeFactura];  
    else arrayAnular = arrayFacturas.filter((factura) => itemsAnular.includes(factura?.DetallesDTE?.identificacion?.numeroControl));

    anularFactura(arrayAnular);
  }

  useEffect(() => {
    if (resultAnulaciones.length > 0) {
      historialHandleAnulaciones();
      getTransactions(formFilter);
    }
  }, [resultAnulaciones]);

  const emailReceptor = useMemo(() => {
    if (!activeFactura) { return ''; }
    const {DetallesDTE: {sujetoExcluido, receptor, identificacion}} = activeFactura;
    const emailsEnvio = identificacion?.ReceptorEmailsEnvio;
    if (emailsEnvio) {
      return [...emailsEnvio.split(',')];
    } else {
      const clienteReceptor = receptor ?? sujetoExcluido;
      return [clienteReceptor?.correo];
    }
  }, [activeFactura])

  return (
    <>
      {(activeOpciones) && 
        (<ModalHistorialAcciones
          factura={activeFactura}
          qrCode={generateQRImageFromBits(qrFactura?.replace("data:image/jpeg;base64,", ""))}
          anulado={anulado} 
          onCancel={() => dispatch(setStatusModalOpciones(false))}
        />)
      }
      {(activeEnvioCorreo) && 
        (<ModalEnviarEmail
          defaultEmail={''}
          chipsEmail={emailReceptor}
          showBackBtn={true}
          onBackBtn={() => dispatch(setStatusModalEnvio(false))} 
          onSendEmail={handleEnviarEmail}
        />)
      }
      {(activeAnular) && 
        (<ModalAnularFactura 
          closeModalEliminar={() => dispatch(setStatusModalAnular(false))}
          actionEliminar={handleAnular}
          detail={
            activeFactura 
            ? activeFactura?.DetallesDTE?.identificacion?.numeroControl
            : <ul>{itemsAnular.map((item) => <li>{item}</li>)}</ul>
          }
        />)
      }
      {(activePrint) && 
        (<ModalImprimirFactura 
          documento={activeFactura?.documento}
          sello={activeFactura?.sellorecibido}          
          onCancel={() => dispatch(setStatusModalImprimir(false))}
          onPrint={() => dispatch(setStatusModalImprimir(false))}
        />)
      }
    </>
  )
}

export default ModalsControl;
